import { createContext, useContext } from "react";

import type { ExhibitScheme, FsNode } from "../caseFiles/types";

/**
 * What a citation chip needs to resolve itself: the case's files and live
 * labels, and a way to open a file at a page. Optional on purpose: a chip
 * rendered outside the case IDE (or in a test) falls back to the label the
 * marker carried, with no hover card.
 */
export type CitationSource = {
  individualId: string;
  nodes: readonly FsNode[];
  labels: Record<string, string | null>;
  scheme: ExhibitScheme;
  open: (node: FsNode, page: number | null) => void;
};

const CitationSourceContext = createContext<CitationSource | null>(null);

export const CitationSourceProvider = CitationSourceContext.Provider;

export const useCitationSource = (): CitationSource | null =>
  useContext(CitationSourceContext);
